import React from "react";
import WaveText from "../WaveText";

export default function WordTranslationGeneratorPanel({
  showWordTranslationGenerator, generatedWordTranslations, showAskMe, showTemplates,
  showWordDefinitionGenerator, showTrueFalseGenerator, showWarmUpDiscussionGenerator,
  showCreateDialogueGenerator, showEssentialVocabularyGenerator, showLeadInActivitiesGenerator,
  showFourOpinionsGenerator, showCommunicativeSituationsGenerator, showMatchingHalvesGenerator,
  showErrorCorrectionGenerator, showGrammarRulesGenerator,
  wordTranslationInput, setWordTranslationInput,
  wordTranslationTargetLanguage, setWordTranslationTargetLanguage,
  wordTranslationLoading,
  handleWordTranslationGenerate, handleWordTranslationInsert, handleWordTranslationCancel,
}) {
  if (!((showWordTranslationGenerator || generatedWordTranslations) && !showAskMe && !showTemplates && !showWordDefinitionGenerator && !showTrueFalseGenerator && !showWarmUpDiscussionGenerator && !showCreateDialogueGenerator && !showEssentialVocabularyGenerator && !showLeadInActivitiesGenerator && !showFourOpinionsGenerator && !showCommunicativeSituationsGenerator && !showMatchingHalvesGenerator && !showErrorCorrectionGenerator && !showGrammarRulesGenerator)) {
    return null;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, transition: 'opacity 0.22s, transform 0.22s' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <button onClick={handleWordTranslationCancel} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, marginRight: 4, transition: 'color 0.18s' }}>
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none"><path d="M12 16l-4-4 4-4" stroke="#8a2be2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </button>
        <span style={{ fontSize: 16, fontWeight: 600, color: '#22223b' }}>Generate Word-Translation Matching</span>
      </div>

      <textarea
        value={wordTranslationInput}
        onChange={e => setWordTranslationInput(e.target.value)}
        placeholder="Enter a list of words (one per line or separated by commas)..."
        rows={4}
        style={{
          fontSize: 15,
          padding: '12px',
          borderRadius: 8,
          border: '1.5px solid #cfcfff',
          background: '#f7fbff',
          resize: 'vertical',
          fontFamily: 'Inter, Segoe UI, Arial, sans-serif',
          width: '100%',
          boxSizing: 'border-box'
        }}
      />

      <div style={{ display: 'flex', gap: 8, marginBottom: 8, flexWrap: 'wrap' }}>
        <label style={{ fontSize: 14, fontWeight: 500, color: '#22223b', display: 'flex', alignItems: 'center', gap: 8 }}>
          Target Language:
          <select
            value={wordTranslationTargetLanguage}
            onChange={e => setWordTranslationTargetLanguage(e.target.value)}
            style={{
              fontSize: 14,
              padding: '6px 8px',
              borderRadius: 6,
              border: '1.5px solid #cfcfff',
              background: '#fff',
              cursor: 'pointer'
            }}
          >
            <option value="Chinese">Chinese (中文)</option>
            <option value="Spanish">Spanish (Español)</option>
            <option value="Hindi">Hindi (हिन्दी)</option>
            <option value="Portuguese">Portuguese (Português)</option>
            <option value="Russian">Russian (Русский)</option>
            <option value="Japanese">Japanese (日本語)</option>
            <option value="French">French (Français)</option>
            <option value="Italian">Italian (Italiano)</option>
            <option value="German">German (Deutsch)</option>
            <option value="Turkish">Turkish (Türkçe)</option>
            <option value="Korean">Korean (한국어)</option>
            <option value="Arabic">Arabic (العربية)</option>
          </select>
        </label>
      </div>

      <button
        onClick={handleWordTranslationGenerate}
        disabled={wordTranslationLoading || !wordTranslationInput.trim()}
        className={wordTranslationLoading ? 'magic-generating-btn' : 'magic-btn'}
        style={{
          fontSize: 15,
          padding: '12px 16px',
          borderRadius: 8,
          border: 'none',
          background: wordTranslationLoading || !wordTranslationInput.trim() ? '#e0e0e0' : '#8a2be2',
          color: wordTranslationLoading || !wordTranslationInput.trim() ? '#999' : '#fff',
          fontWeight: 600,
          cursor: wordTranslationLoading || !wordTranslationInput.trim() ? 'not-allowed' : 'pointer',
          transition: 'all 0.2s'
        }}
      >
        {wordTranslationLoading ? <WaveText /> : 'Do the magic'}
      </button>

      {generatedWordTranslations && (
        <div style={{ marginTop: 12, padding: 12, background: '#f8f9fa', borderRadius: 8, border: '1px solid #e9ecef' }}>
          <div style={{ fontSize: 14, fontWeight: 600, color: '#22223b', marginBottom: 8 }}>
            Generated: Word-Translation Matching Exercise
          </div>
          <div style={{ fontSize: 13, color: '#6c757d', marginBottom: 12 }}>
            {generatedWordTranslations.pairs.length} word-translation pairs ready
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button
              onClick={handleWordTranslationInsert}
              className="magic-btn"
              style={{ fontSize: 14, padding: '8px 16px', borderRadius: 6, fontWeight: 600, cursor: 'pointer', width: '100%' }}
            >
              Add
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
